const ResidentialPlansStatus = {
  ALL: 0,
  APPROVE: 1,
  NOT_APPROVE: 2,
}

export default ResidentialPlansStatus
